
import React, { useContext, useState, useCallback, useEffect } from 'react'
import styled, { ThemeContext } from 'styled-components'
import { Text } from 'rebass'
import { BigNumber } from '../../../sushi'
import { BIGNUMBER_FMT } from '../../../constants/bakery'

import { 
  getCarBnbBlpContract, 
  getCarContract, 
  getWethContract,
  getCarNFTInfo,
  getCarNFTContract,
} from '../../../sushi/utils'

// components
import LockTokenModal from '../components/LockTokenModal'
import UnlockTokenModal from '../components/UnlockTokenModal'

// hooks
import useBlock from '../../../hooks/bakery/useBlock'
import usePokerCardRoi from '../../../hooks/nft/usePokerCardRoi'
import { usePrice } from '../../../hooks/usePrice'
import useYam from '../../../hooks/bakery/useYam'
import useUserStakes from '../../../hooks/nft/useUserStakes'
import useModal from '../../../hooks/bakery/useModal'

const ArtworkLevel = styled.div`
  display: flex;
  margin-bottom: 15px;
  width: 100%;
  height: 17px;
  justify-content: space-between;
`
const NumbeNWrapper = styled.div`
  display: flex;
  border: 1px solid ${({ theme }) => theme.bsText2};
  color: ${({ theme }) => theme.bsText7};
  border-radius: 4px;
  width: 100px;
  height: 24px;
  overflow:hidden;
  justify-content: space-between;
  align-items: center;
`
const Minus = styled.div`
  color: ${({ theme }) => theme.bsText3};
  width: 24px;
  height:24px;
  text-align:center;
  border-right: 1px solid ${({ theme }) => theme.bsText2};
`
const Plus = styled(Minus)`
  border-left: 1px solid ${({ theme }) => theme.bsText2};
  border-right: 0px;
`

export function InfoSolt ({artwork, type, isMyArtwork}: {artwork: any, type: string, isMyArtwork: boolean}) {
  const theme = useContext(ThemeContext)
  const sushi = useYam()
  const symbol = 'BAKE'

  // 获取我的stake
  const getStakes = useUserStakes(type)
  const emptyStakes: any[] = []
  const [stakesIds, setStakesIds] = useState(emptyStakes)
  const getStakesIds = useCallback(async () => {
    const stakes = await getStakes()
    if (stakes.length) {
      const stakesId = stakes.map((d: any) => {
        return d
      })
      setStakesIds(stakesId)
    } else {
      setStakesIds([])
    }
  }, [getStakes])

  useEffect(() => {
    getStakesIds()
  }, [artwork, getStakesIds])


  // 锁币到扑克牌
  const [isShowModal, setIsShowModal] = useState(false)
  const [randomNum, setRandomNum] = useState(0)
  const [tokenName, setTokenName] = useState("")
  const [modalType, setModalType] = useState("")
  const Contract = getCarNFTContract(sushi)

  const [lockedCAR, setLockedCAR] = useState(0)
  const [stakingPower, setStakingPower] = useState(new BigNumber(0))
  // 获取car power
  const fetchCarNFTInfo = useCallback(async() => {
    let carInfo = await getCarNFTInfo(Contract, artwork.tokenId ? artwork.tokenId : artwork.nftId)
    setLockedCAR(carInfo.lockedCAR?.toNumber())
    setStakingPower(carInfo.stakingPower)
  }, [getCarNFTInfo, artwork])

  useEffect(() => {
    fetchCarNFTInfo()
  }, [fetchCarNFTInfo])

  const [lockToken] = useModal(
    <LockTokenModal
      tokenId={artwork.tokenId}
      title={'Lock ' + tokenName}
      tokenName={tokenName}
      stakingPower={new BigNumber(stakingPower).toNumber()}
    />
  )

  const [unlockToken] = useModal(
    <UnlockTokenModal
      tokenId={artwork.tokenId}
      title={'Unlock ' + tokenName}
      tokenName={tokenName}
      lockedCAR={lockedCAR}
      stakingPower={new BigNumber(stakingPower).toNumber()}
    />
  )

  const updateName = useCallback(() => {
    if (isShowModal && modalType === 'lock') {
      lockToken()
    }
    if (isShowModal && modalType === 'unlock') {
      unlockToken()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tokenName, isShowModal, randomNum])

  useEffect(() => {
    updateName()
  }, [updateName])
  
  const onPresentExchange = useCallback(async (event, type, tname) => {
    // pet bake poker
    setTokenName(tname)
    // lock  unlock
    setModalType(type)
    setIsShowModal(true)
    // updateName 调用
    const rdm = Math.random()
    setRandomNum(rdm)
  }, [])

  // 计算rio
  const currentBlock = useBlock()
  // car转bnb
  const carBnbPrice = usePrice(getCarBnbBlpContract(sushi), getCarContract(sushi), getWethContract(sushi))
  const carTotalBnb = carBnbPrice ? carBnbPrice.toNumber() : 0 * lockedCAR
  let transformBnbPrice = 2 + carTotalBnb
  const pokerRoi = usePokerCardRoi(currentBlock, type, new BigNumber(stakingPower).toNumber(),transformBnbPrice)
  const roi  = pokerRoi || new BigNumber(0)

  return (
    <>
      {
        artwork && artwork ?
        <>
          <ArtworkLevel>
            <Text fontSize={14} color={artwork.level ==='v3' || isMyArtwork ? theme.bsText7 : '#776D63'}>Current APY:</Text>
            <Text fontSize={14} fontWeight={700} color={artwork.level ==='v3' || isMyArtwork ? theme.bsText7 : '#776D63'}>
            {
              artwork.name === 'blindbox' ? (
                <Text fontSize={14} fontWeight={700} color={artwork.level ==='v3' || isMyArtwork ? theme.bsText7 : '#776D63'}>-</Text>
              ) : 
              roi && !roi.isNaN() && roi.gt(0) ? roi.times(new BigNumber(100)).toFormat(2, BIGNUMBER_FMT) + '%' : '-'
            }
            </Text>
          </ArtworkLevel>
          <ArtworkLevel>
            <Text fontSize={14} color={artwork.level ==='v3' || isMyArtwork ? theme.bsText7 : '#776D63'}>Staking Power:</Text>
            {
              artwork.name === 'blindbox' ? (
                <Text fontSize={14} fontWeight={700} color={artwork.level ==='v3' || isMyArtwork ? theme.bsText7 : '#776D63'}>-</Text>
              ) : (
                <Text fontSize={14} fontWeight={700} color={artwork.level ==='v3' || isMyArtwork ? theme.bsText7 : '#776D63'}>{stakingPower ? new BigNumber(stakingPower).toNumber() : '-'}</Text>
              )
            }
          </ArtworkLevel>
          <ArtworkLevel>
            <Text fontSize={14} color={artwork.level ==='v3' || isMyArtwork ? theme.bsText7 : '#776D63'}>CAR Locked:</Text>
            {
              artwork.name === 'blindbox' ? (
                <Text fontSize={14} fontWeight={700} color={artwork.level ==='v3' || isMyArtwork ? theme.bsText7 : '#776D63'}>-</Text>
              ) :
                (
                  <NumbeNWrapper>
                    {
                      lockedCAR && new BigNumber(lockedCAR).toNumber()  && !stakesIds.includes(artwork.tokenId) && !artwork.price && isMyArtwork ? (
                        <Minus onClick={event => { onPresentExchange(event, 'unlock', 'CAR') }}>-</Minus>
                      ) : (
                        <Minus style={{color: theme.bsBorder2}}>-</Minus>
                      )
                    }
                    <Text fontSize={14} fontWeight={700} color={artwork.level ==='v3' || isMyArtwork ? theme.bsText7 : '#776D63'}>{lockedCAR ? new BigNumber(lockedCAR).toNumber() : 0}</Text>
                    {
                      !stakesIds.includes(artwork.tokenId) && !artwork.price && isMyArtwork ? (
                        <Plus onClick={event => { onPresentExchange(event, 'lock', 'CAR') }}>+</Plus>
                      ): (
                        <Plus style={{color: theme.bsBorder2}}>+</Plus>
                      )
                    }
                  </NumbeNWrapper>
                )
            }
          </ArtworkLevel>
          <ArtworkLevel>
            <Text fontSize={14} color={artwork.level ==='v3' || isMyArtwork ? theme.bsText7 : '#776D63'}>Price:</Text>
            <Text fontSize={14} fontWeight={700} color={artwork.level ==='v3' || isMyArtwork ? theme.bsText7 : '#776D63'}>
              {artwork.price 
              ? (new BigNumber(!artwork.auctionPrice ? artwork.price : artwork.maxBidPrice).integerValue(BigNumber.ROUND_CEIL).toFormat(0, BIGNUMBER_FMT) + ' ' + symbol) 
              : '-'}
            </Text>
          </ArtworkLevel>
        </> : null
      }
    </>
  )
}
